/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spelling_Numbers_CompleteInputs */

const en_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelling numbers #0-10 complete`)
};

const fr_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épellation des chiffres #0-10 terminée`)
};

const de_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchstabieren der Zahlen 0-10 vollständig`)
};

const it_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamento dell'ortografia dei numeri da 0 a 10`)
};

const ru_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Написание цифр от 0 до 10 завершено`)
};

const es_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deletrear números del 0 al 10 completo`)
};

const zh_cn2_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拼写数字 #0-10 完成`)
};

const ja_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字のスペリング #0-10 完了`)
};

const hi_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संख्या 0-10 की वर्तनी पूरी करें`)
};

const pt_pt2_spelling_numbers_complete = /** @type {(inputs: Spelling_Numbers_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva os números de 0 a 10 por extenso.`)
};

/**
* | output |
* | --- |
* | "Spelling numbers #0-10 complete" |
*
* @param {Spelling_Numbers_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spelling_numbers_complete = /** @type {((inputs?: Spelling_Numbers_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spelling_Numbers_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spelling_numbers_complete(inputs)
	if (locale === "de") return de_spelling_numbers_complete(inputs)
	if (locale === "it") return it_spelling_numbers_complete(inputs)
	if (locale === "ru") return ru_spelling_numbers_complete(inputs)
	if (locale === "es") return es_spelling_numbers_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_spelling_numbers_complete(inputs)
	if (locale === "ja") return ja_spelling_numbers_complete(inputs)
	if (locale === "hi") return hi_spelling_numbers_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_spelling_numbers_complete(inputs)
	return en_spelling_numbers_complete(inputs)
});